import { createRouter, createWebHistory } from 'vue-router'
import { getToken } from '@/api/client'
import { useSessionStore } from '@/stores/session'

/**
 * 화면 길.
 *
 * <p>손님은 <b>예약 하나</b>만 봅니다. 그래서 길도 얕습니다 —
 * 확인하고 들어와서, 예약 안내를 보고, 필요하면 계약·서류를 봅니다.</p>
 *
 * <p><b>레거시에는 이 문이 없었습니다.</b> 예약번호가 화면에 박혀 있어 아무나
 * 열 수 있었습니다. 여기서는 확인을 거치지 않으면 어느 화면도 안 열립니다.</p>
 */
export const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'find',
      component: () => import('@/views/FindView.vue'),
      meta: { anonymous: true, title: '내 예약 확인' },
    },
    {
      path: '/reservation',
      name: 'reservation',
      component: () => import('@/views/ReservationView.vue'),
      meta: { title: '예약 안내' },
    },
    {
      path: '/checkin',
      name: 'checkin',
      component: () => import('@/views/CheckInView.vue'),
      meta: { title: '체크인' },
    },
    {
      path: '/trip',
      name: 'trip',
      component: () => import('@/views/TripView.vue'),
      meta: { title: '이용 내역' },
    },
    {
      path: '/reports',
      name: 'reports',
      component: () => import('@/views/ReportsView.vue'),
      meta: { title: '도움 요청' },
    },
    {
      path: '/reports/accident',
      name: 'accident',
      component: () => import('@/views/AccidentView.vue'),
      meta: { title: '사고 접수' },
    },
    {
      path: '/reports/lost',
      name: 'lost',
      component: () => import('@/views/LostView.vue'),
      meta: { title: '분실물 신고' },
    },
    {
      path: '/chat',
      name: 'chat',
      component: () => import('@/views/ChatView.vue'),
      meta: { title: '상담 채팅' },
    },
    // 예약 문의(한 번 묻고 답 받기)는 상담 채팅이 대신합니다. 옛 주소는 채팅으로.
    { path: '/inquiry', redirect: { name: 'chat' } },
    {
      path: '/documents',
      name: 'documents',
      component: () => import('@/views/DocumentsView.vue'),
      meta: { title: '증빙서류' },
    },
    // 없는 주소는 처음 화면으로 돌립니다 — 손님에게 "없는 페이지" 를 보여 줄
    // 이유가 없습니다.
    { path: '/:pathMatch(.*)*', redirect: { name: 'find' } },
  ],
})

router.beforeEach((to) => {
  const session = useSessionStore()

  if (to.meta.anonymous) {
    // 이미 확인했으면 예약 안내로 바로 보냅니다.
    return session.isVerified() ? { name: 'reservation' } : true
  }

  // 열쇠가 없으면 아무것도 못 봅니다.
  if (!getToken() || !session.isVerified()) return { name: 'find' }
  return true
})

router.afterEach((to) => {
  const title = typeof to.meta.title === 'string' ? to.meta.title : null
  document.title = title ?? '내 예약'
})
